import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useHistory } from 'react-router-dom';
import differenceInDays from 'date-fns/differenceInDays'
import Helper from "../providers/Helpers";
import commandsProvider from "../providers/CommandsProvider";
import PanelModelEnum from "../enums/PanelModeEnum";
import GuardiaoStatusEnum from "../enums/GuardiaoStatusEnum";
import EventCommandEnum from "../enums/EventCommandEnum";
//import { error } from "console";

const CompareArrays = (array1, array2) => {
    if (array1.length !== array2.length) {
        return false;
    }
    for (let i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) {
            return false;
        }
    }
    return true;
};

const licenceName = (licenceType) => {
    if (licenceType === "d") {
        return "PRO Local"
    }
    if (licenceType === "f") {
        return "Free"
    }
    if (licenceType === "t") {
        return "Técnico"
    }
    if (licenceType === "r") {
        return "Integrador"
    }
    if (licenceType === "w") {
        return "Web"
    }
    if (licenceType === "m") {
        return "Master"
    }
}

export default function SystemData(props) {
    const memoModemStatus = useMemo(() => props.modemStatus, [props.modemStatus]);
    const memoToken = useMemo(() => props.token, [props.token]);
    //const [desktopStatus, setDesktopStatus] = useState("não informado");
    const [guardiaoStatus, setGuardiaoStatus] = useState(GuardiaoStatusEnum.NAO_INFORMADO);
    const [panelStatus, setPanelStatus] = useState("não informado");
    const [coordinator, setCoordinator] = useState({});
    const [onlineAmplifiers, setOnlineAmplifiers] = useState([]);
    const [amplifiers, setAmplifiers] = useState([]);
    const [events, setEvents] = useState([]);
    const [alarms, setAlarms] = useState([]);
    const [noPower, setNoPower] = useState(false);
    const [panelMode, setPanelMode] = useState(commandsProvider.getPanelMode());
    const [network, setNetwork] = useState({});
    const [semRedeAC, setSemRedeAC] = useState(false)
    const [syncing, setSyncing] = useState(false);
    const [hideAmplifier, setHideAmplifier] = useState(true);
    const [licences, setLicences] = useState([]);

    // Estados para controlar alertas visuais
    const [hasNewEvent, setHasNewEvent] = useState(false);
    const [hasNewAlarm, setHasNewAlarm] = useState(false);

    // Refs para rastrear o estado atual sem causar re-renders
    const hasNewEventRef = useRef(false);
    const hasNewAlarmRef = useRef(false);

    // ✅ REMOVIDO: alarmsInitialized, eventsInitialized refs
    // Não são mais necessários com a centralização no CommandsProvider

    // Novo estado para licença usando informações da sessão
    const [licenseInfo, setLicenseInfo] = useState({
        type: commandsProvider.session.getLicenseType(),
        validDays: commandsProvider.session.getLicenseValidDays(),
        isValid: commandsProvider.session.isLicenseValid(),
        elements: commandsProvider.session.getLicenseElements()
    });

    const CheckPanelStatus = (lastTimeUpdate) => {
        let last = new Date(lastTimeUpdate);
        let current = new Date();
        let minutes = Math.floor((current.getTime() - last.getTime()) / 60000);


        if (minutes > 10) {
            setPanelStatus("offline");
        }
        else {
            setPanelStatus("online");
        }
    }
    useEffect(() => {
        commandsProvider.forceCheckLicenseStatus();
    }, []);

    useEffect(() => {
        async function fetchLicences() {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/licences/client/licences?serialNumber=${props.systemData.serialKeys}`, {
                    method: 'GET',
                    headers: {
                        "content-type": "application/json",
                        "Authorization": "Bearer " + props.token
                    }
                });
                const data = await response.json();
                console.log("Tipos de licença:", data.map(l => l.tipo_licenca));
                setLicences(data);
                
                console.log("Licenças retornadas:", data);
            } catch (error) {
                setLicences([]);
            }
        }
        fetchLicences();
    }, [props.systemData.serialKeys, props.token]);

    const getLicenceDisplayName = () => {
        const now = new Date();
        const hasDesktop = licences.some(l => l.tipo_licenca === "desktop");
        //const hasWeb = licences.some(l =>
        //    l.tipo_licenca === "web" &&
        //    new Date(l.expiracao_licenca) > now 
        //);
        const hasWeb = licences.some(l => {
            if (l.tipo_licenca !== "web" || !l.expiracao_licenca || !l.chave_utilizada) return false;
            const exp = new Date(l.expiracao_licenca);
            return !isNaN(exp) && exp > now;
        });
        
        if (hasDesktop && hasWeb) {
            return (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    lineHeight: "1.1rem",
                    gap: "0.8rem" 
                }}>
                    <span>Pro Local</span>
                    <span style={{
                        fontSize: "1rem",
                        lineHeight: "1rem",
                        margin: "0"
                    }}>+</span>
                    <span>Web</span>
                </div>
            );
        }

        //if (hasDesktop) return "PRO LOCAL";
        //if (hasWeb) return "WEB";
        return licenseInfo.type;
    };

    // ✅ REMOVIDO: checkInitialAlarmState, checkInitialEventState, checkCrossReset
    // Agora o estado do pulso é gerenciado centralmente pelo CommandsProvider

    const GetDailyAlarms = useCallback(async () => {
        try {
            if (!!sessionStorage.getItem("serial")) {
                const response = await fetch(`${process.env.REACT_APP_URL}/command/all`, {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        "Authorization": "Bearer " + memoToken
                    },
                    body: JSON.stringify({
                        "serialNumber": sessionStorage.getItem("serial"),
                    })
                });

                if (!response.ok) {
                    throw new Error("Não foi possível buscar os Alarmes do Dia");
                }

                const res = await response.json();

                // ✅ REMOVIDO: Lógica de detecção de novos alarmes
                // O pulso agora é controlado pelo CommandsProvider baseado em groupAlarms

                setAlarms(res);
            }
            else {
                throw new Error("O Serial não foi informado. Nova tentativa será realizada!");
            }
        }
        catch (error) {
            console.log("🚀 ~ GetDailyAlarms ~ error:", error)
        }
        finally {
            setTimeout(GetDailyAlarms, 5000);
        }

        return () => { console.log("Finish GetDailyAlarms"); }
    }, [alarms.length, memoToken]);

    const GetDailyEvents = useCallback(async () => {
        try {
            if (!!sessionStorage.getItem("serial")) {
                const response = await fetch(`${process.env.REACT_APP_URL}/events/all?serialNumber=${sessionStorage.getItem("serial")}`, {
                    method: "GET",
                    headers: {
                        "content-type": "application/json",
                        "authorization": `Bearer ${memoToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error("Não foi possível buscar os Eventos diários");
                }

                const res = await response.json();

                // ✅ REMOVIDO: Lógica de detecção de novos eventos
                // O pulso agora é controlado pelo CommandsProvider baseado em groupEvents

                setEvents(res);
            }
            else {
                throw new Error("O Serial não foi informado. Nova tentativa será realizada!");
            }
        }
        catch (error) {
            console.log("🚀 ~ GetDailyEvents ~ error:", error);
        }
        finally {
            setTimeout(GetDailyEvents, 5000);
        }

        return () => { console.log("Finish GetDailyEvents"); }
    }, [events.length, memoToken]);

    const GetDesktopStatusBySerial = useCallback(async () => {
        try {
            if (!!sessionStorage.getItem("serial")) {
                const response = await fetch(`${process.env.REACT_APP_URL}/panel/last?centralSerial=${sessionStorage.getItem("serial")}`, {
                    method: "GET",
                    headers: {
                        "content-type": "application/json",
                        "authorization": `Bearer ${memoToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error("Falha ao buscar dados do Modo de Operação");
                }

                const res = await response.json();

                if (res.status != "SEM REDE AC") {
                    setPanelMode(res.status);
                }
                //else {
                //    setNoPower(true);
                //}
            }
            else {
                throw new Error("O Serial não foi informado. Nova tentativa será realizada!");
            }
        }
        catch (error) {
            console.log("🚀 ~ GetDesktopStatusBySerial ~ error:", error)
        }
        finally {
            setTimeout(GetDesktopStatusBySerial, 10000);
        }

        return () => { console.log("Finish GetDesktopStatusBySerial"); }
    }, []);

    const GetCoordinator = useCallback(() => {
        let data = JSON.parse(sessionStorage.getItem("coordinator"));

        if (!!data) {
            //setPanelStatus(data.panelStatus);
            if (data.panelStatus === "online") {
                CheckPanelStatus(data.coordinator.dT_AMPLIFICADOR);
            }
            else {
                setPanelStatus("offline");
            }

            setCoordinator(data.coordinator);
        }

        setTimeout(GetCoordinator, 10000);
    }, []);

    const GetAmplifiersByCentralSerial = useCallback(async () => {
        if (!!props.modemConnected) {
            try {
                if (!!sessionStorage.getItem("serial")) {
                    const response = await fetch(`${process.env.REACT_APP_URL}/amplifier/all`, {
                        method: "POST",
                        headers: {
                            "content-type": "application/json",
                            "authorization": `Bearer ${memoToken}`
                        },
                        body: JSON.stringify({ "serialNumber": sessionStorage.getItem("serial") })
                    });

                    if (!response.ok) {
                        throw new Error("Falha ao buscar dados de amplificadores");
                    }

                    const res = await response.json();

                    setAmplifiers(res.filter(amplifier => amplifier.dS_NOME !== "Modem" && amplifier.dS_NOME !== "Central"));
                    setOnlineAmplifiers(res.filter(amplifier => (amplifier.dS_STATUS === "online" || amplifier.dS_STATUS === "buscando") && amplifier.dS_NOME !== "Modem" && amplifier.ds_NOME !== "Central"));
                }
                else {
                    throw new Error("O Serial não foi informado. Nova tentativa será realizada!");
                }
            }
            catch (error) {
                console.log("🚀 ~ GetAmplifiersByCentralSerial ~ error:", error)
            }
            finally {
                setTimeout(GetAmplifiersByCentralSerial, 2000);
            }

            return () => { console.log("Finish GetAmplifiersByCentralSerial"); }
        }
    }, []);

    const NetworkStatus = useCallback(() => {
        let amplifiers = JSON.parse(sessionStorage.getItem("amplifiers"));

        if (!!amplifiers) {
            let amplifiersOnline = []
            let onlineCount = []
            let percentage = 0;

            let response = {
                status: "",
                total: 0,
                online: 0,
                working: 0
            };

            amplifiers.online.forEach(amplifier => {
                amplifiersOnline.push(amplifier)
            });

            onlineCount = amplifiersOnline.filter(amplifier => {
                return (amplifier.dS_STATUS === "online" || amplifier.dS_STATUS === "buscando") && amplifier.dS_NOME !== "Central" ? amplifier : null
            });

            percentage = (onlineCount.length * 100) / amplifiers.all.length;

            response.total = amplifiers.all.length;
            response.online = onlineCount.length;
            response.working = percentage;

            switch (true) {
                case (response.working > 0 && response.working <= 19):
                    response.status = "Baixa";
                    break;
                case (response.working > 19 && response.working <= 49):
                    response.status = "Média";
                    break;
                case (response.working > 49 && response.working <= 79):
                    response.status = "Alta";
                    break;
                case (response.working > 79):
                    response.status = "Excelente";
                    break;
                case (response.online === 0 && response.total > 0):
                    response.status = "Necessita Atenção";
                    Helper.Notification('ATENÇÃO, Sinal Baixo!\n\nAcesse a página de Rede e verifique os Amplificadores.', "Rede");
                    break;
                default:
                    response.status = "Sem amplificadores";
                    break;
            }

            setNetwork(response);
        }
    }, []);

    // const CheckDesktopStatusFromWeb = useCallback(async () => {
    //     if (process.env.REACT_APP_MODE === "web") {
    //         try {
    //             if (!!sessionStorage.getItem("serial")) {
    //                 const response = await fetch(`${process.env.REACT_APP_URL}/localstatus/get-by-serial?serialNumber=${sessionStorage.getItem("serial")}`, {
    //                     method: "GET",
    //                     headers: {
    //                         "content-type": "application/json",
    //                         "authorization": `Bearer ${memoToken}`
    //                     }
    //                 });

    //                 if (!response.ok) {
    //                     throw new Error("Falha ao buscar dados do Modo de Operação");
    //                 }

    //                 const res = await response.json();

    //                 if (res.isOpen) {
    //                     setDesktopStatus("online");
    //                 }
    //                 else {
    //                     setDesktopStatus("offline");
    //                 }

    //                 console.log("🚀 ~ CheckDesktopStatusFromWeb ~ res:", res)
    //             }
    //             else {
    //                 throw new Error("O Serial não foi informado. Nova tentativa será realizada!");
    //             }
    //         }
    //         catch (error) {
    //             console.log("🚀 ~ GetDesktopStatusBySerial ~ error:", error)
    //         }
    //         finally {
    //             setTimeout(CheckDesktopStatusFromWeb, 10000);
    //         }

    //         return () => { console.log("Finish CheckDesktopStatusFromWeb"); }
    //     }
    //     else {
    //         return () => { console.log("Ambiente Desktop identificado, pulando CheckDesktopStatusFromWeb"); }
    //     }
    // }, [])

    const getIconByPanelMode = (panelMode) => {
        //console.log("TESTE PANEL MODE: ----->>>>>", panelMode)
        if (panelMode === PanelModelEnum.NAO_INFORMADO) {
            return <i className="fa fa-cogs fa-4x color-disabled" aria-hidden="true"></i>;
        }
        if (panelMode === PanelModelEnum.NORMAL) {
            return <i className="fa fa-cogs fa-4x color-success" aria-hidden="true"></i>;
        }
        if (panelMode === PanelModelEnum.PARCIAL) {
            return <i className="fa fa-cogs fa-4x color-warning" aria-hidden="true"></i>;
        }
        if (panelMode === PanelModelEnum.SSPMANUAL) {
            return <i className="fa fa-cogs fa-4x color-info" aria-hidden="true"></i>;
        }
        if (panelMode === PanelModelEnum.SSPAUTO) {
            return <i className="fa fa-cogs fa-4x color-info" aria-hidden="true"></i>;
        }
        //if (panelMode.includes([PanelModelEnum.SSPAUTO, PanelModelEnum.SSPMANUAL])) {
        //    return <i className="fa fa-cogs fa-4x color-info" aria-hidden="true"></i>;
        //} 
        return null;
    };

    const renderDesktopIcon = () => {
        if (!props.modemStatus.status || props.systemData.serialPortError) {
            return <i className="fa fa-cogs fa-4x color-disabled" aria-hidden="true"></i>;
        }
        return getIconByPanelMode(panelMode);
    };

    const renderWebIcon = () => {
        if (guardiaoStatus === GuardiaoStatusEnum.NAO_INFORMADO || 
            guardiaoStatus === GuardiaoStatusEnum.OFFLINE ||
            guardiaoStatus === GuardiaoStatusEnum.ONLINE_SEM_MODEM) {
            return <i className="fa fa-cogs fa-4x color-disabled" aria-hidden="true"></i>;
        }
        return getIconByPanelMode(panelMode);
    };

    const updateViewState = (state) => 
    {
        setGuardiaoStatus(state.guardiaoStatus);

        if (Object.values(PanelModelEnum).includes(state.panelMode))
        {
            setPanelMode(state.panelMode);
        }

        if (!state.ACDCStatus) {
            if (
                sessionStorage.getItem("showNoACDC") === "true" &&
                (
                    Array.isArray(state.groupEvents) &&
                    state.groupEvents.some(ev => ev.memory === "9999")
                )
            ) {
                setNoPower(true);
            }
            else {
                setNoPower(false);
            }
        }
        else {
            setNoPower(false);
        }

        // ✅ SOLUÇÃO SIMPLES: Usa o estado gerenciado pelo CommandsProvider

        // 🔍 DEBUG: Detecta mudanças EXTERNAS nos refs (alguém está setando fora do updateViewState)
        const eventRefWasChangedExternally = hasNewEventRef.current !== state.shouldPulseEvents;
        const alarmRefWasChangedExternally = hasNewAlarmRef.current !== state.shouldPulseAlarms;

        if (eventRefWasChangedExternally || alarmRefWasChangedExternally) {
            console.log("🔍 SystemData updateViewState CHAMADO:", {
                shouldPulseEvents: state.shouldPulseEvents,
                shouldPulseAlarms: state.shouldPulseAlarms,
                eventsCount: state.groupEvents?.length || 0,
                alarmsCount: state.groupAlarms?.length || 0,
                currentEventRef: hasNewEventRef.current,
                currentAlarmRef: hasNewAlarmRef.current,
                stackTrace: new Error().stack.split('\n').slice(1, 4).join('\n')
            });
        }

        // Apenas sincroniza com o estado do provider (fonte única da verdade)
        if (hasNewEventRef.current !== state.shouldPulseEvents) {
            console.log(`📊 Eventos: Atualizando pulso ${hasNewEventRef.current} → ${state.shouldPulseEvents}`);
            hasNewEventRef.current = state.shouldPulseEvents;
            setHasNewEvent(state.shouldPulseEvents);
        }

        if (hasNewAlarmRef.current !== state.shouldPulseAlarms) {
            console.log(`🚨 Alarmes: Atualizando pulso ${hasNewAlarmRef.current} → ${state.shouldPulseAlarms}`);
            hasNewAlarmRef.current = state.shouldPulseAlarms;
            setHasNewAlarm(state.shouldPulseAlarms);
        }

        // New license info handling
        if (state.session) {
            setLicenseInfo({
                type: state.session.getLicenseType(),
                validDays: state.session.getLicenseValidDays(),
                isValid: state.session.isLicenseValid(),
                elements: state.session.getLicenseElements()
            });
        }        
    }

    // Funções de navegação (apenas para Desktop)
    const history = useHistory();

    const isFree = licenseInfo.type === 'Free';

    const navigateToAmplifiers = () => {
        if (process.env.REACT_APP_MODE === 'desktop' && !isFree) {
            history.push('/amplificadores');
        }
    };

    const navigateToEvents = () => {
        if (process.env.REACT_APP_MODE === 'desktop' && !isFree) {
            history.push('/eventos');
        }
    };

    const navigateToAlarms = () => {
        if (process.env.REACT_APP_MODE === 'desktop' && !isFree) {
            history.push('/alarmes');
        }
    };

    const navigateToLicenses = () => {
        if (process.env.REACT_APP_MODE === 'desktop' && !isFree) {
            history.push('/usuarios?tab=1');
        }
    };

    const openUpdateModal = () => {
        if (process.env.REACT_APP_MODE === 'desktop' && !isFree) {
            const updateButton = document.querySelector('.hidden[data-action="update-system"]');
            if (updateButton) updateButton.click();
        }
    };

    // Helper para retornar classe e onClick apenas no Desktop (e não Free)
    const getClickableClass = () => {
        return process.env.REACT_APP_MODE === 'desktop' && !isFree ? 'info-box--clickable' : '';
    };

    // Helper para retornar classe correta da segunda linha baseado no modo
    const getSecondRowClass = () => {
        // No modo web: 4 cards na segunda linha (usa row3 para 4 colunas)
        // No modo desktop: 5 cards na segunda linha (usa row4 para 5 colunas)
        return process.env.REACT_APP_MODE === 'web' ? 'info-box--row3' : 'info-box--row4';
    };

    //VERIFICAR A NECESSIDADE DO REFRESH AO ENTRAR NO MENU
    useEffect(() => {
        document.querySelector('.hidden[data-action="refresh-system"]').click();
    }, []);

    useEffect(() => {
        if (process.env.REACT_APP_MODE === "web") {
            GetDesktopStatusBySerial()
        }
    }, [GetDesktopStatusBySerial]);
    useEffect(GetCoordinator, [GetCoordinator, amplifiers]);
    useEffect(GetDailyEvents, [GetDailyEvents]);
    useEffect(GetDailyAlarms, [GetDailyAlarms]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (coordinator.dS_DL === props.amplifierChange.amplifier) {
                //setPanelStatus(props.amplifierChange.status)
            }
            else {
                const updatedAmplifiers = amplifiers.map(amplifier => {
                    if (amplifier.dS_DL === props.amplifierChange.amplifier) {
                        return { ...amplifier, dS_STATUS: props.amplifierChange.status };
                    }
                    return amplifier;
                });

                if (!CompareArrays(updatedAmplifiers, amplifiers)) {
                    setAmplifiers(updatedAmplifiers);
                }
            }
        }, 10000);

        return () => clearInterval(interval);
    }, [props.amplifierChange, amplifiers, coordinator]);

    useEffect(() => {
        var amplifierExists = amplifiers.find(amplifier => amplifier.dS_NUMSERIE === props.newAmplifier.dS_NUMSERIE)

        if (typeof amplifierExists === 'undefined') {
            var updateAmplifierList = [...amplifiers]
            updateAmplifierList.push(props.newAmplifier)
            setAmplifiers(updateAmplifierList)
        }
    }, [props.newAmplifier, amplifiers]);

    useEffect(() => {
        NetworkStatus();

        const interval = setInterval(NetworkStatus, 2000);

        return () => clearInterval(interval);
    }, [NetworkStatus, props.modemStatus])

    useEffect(() => {
        commandsProvider.subscribe(updateViewState);
        return () => commandsProvider.unsubscribe(updateViewState);
    }, []);

    useEffect(() => {
        if (props.timer) {
            setSyncing(true);
        }
        else {
            setSyncing(false);
        }
    }, [props.timer]);

    useEffect(() => {
        if (process.env.REACT_APP_MODE === 'desktop') {
            // Na versão desktop mantém comportamento original
            setHideAmplifier(!props.modemStatus.status || props.serialPortError);
        } else {
            // Na versão web, usa o guardianStatus do CommandsProvider
            setHideAmplifier(!GuardiaoStatusEnum.canShowAmplifiers(guardiaoStatus));
        }
    }, [props.modemStatus, props.serialPortError, guardiaoStatus]);
    
    const licenseWarning = () => {
        if (!!licenseInfo) {
            if (licenseInfo.type === "Técnico" && !licenseInfo.isValid) {
                window.alert("Sua licença de Técnico está inválida.\n\n Entre em contato com o suporte para verificar sua licença.");
            }
        }
    }

    // Função para renderizar ícone de status
    const renderStatusIcon = () => {
        if (process.env.REACT_APP_MODE === 'desktop') {
            return <i className={
                panelStatus === 'não informado' || !props.modemStatus.status || props.systemData.serialPortError 
                    ? "fa fa-tablet fa-4x color-disabled" 
                    : noPower === true 
                        ? "fa fa-tablet fa-4x color-warning" 
                        : panelStatus === 'online' 
                            ? 'fa fa-tablet fa-4x color-success' 
                            : 'fa fa-tablet fa-4x color-danger'
            } aria-hidden="true"></i>;
        }

        return <i className={
            !GuardiaoStatusEnum.canShowAmplifiers(guardiaoStatus)
                ? "fa fa-tablet fa-4x color-disabled"
                : noPower === true
                    ? "fa fa-tablet fa-4x color-warning"
                    : guardiaoStatus === GuardiaoStatusEnum.ONLINE
                        ? 'fa fa-tablet fa-4x color-success'
                        : 'fa fa-tablet fa-4x color-disabled'
        } aria-hidden="true"></i>;
    };

    // Função para renderizar ícone da rede
    const renderNetworkIcon = () => {
        if (process.env.REACT_APP_MODE === 'desktop') {
            return <i className={
                (!props.modemStatus.status || props.systemData.serialPortError) 
                    ? "fa fa-wifi fa-4x color-disabled" 
                    : getNetworkStatusClass(network.working)
            } aria-hidden="true"></i>;
        }

        return <i className={
            !GuardiaoStatusEnum.canShowAmplifiers(guardiaoStatus)
                ? "fa fa-wifi fa-4x color-disabled" 
                : getNetworkStatusClass(network.working)
        } aria-hidden="true"></i>;
    };

    // Helper para definir classe do status da rede
    const getNetworkStatusClass = (working) => {
        if (working >= 50) return "fa fa-wifi fa-4x color-success";
        if (working >= 19) return "fa fa-wifi fa-4x color-warning";
        return "fa fa-wifi fa-4x color-danger";
    };

    // Função para renderizar status do guardião
    const renderGuardiaoStatus = () => {
        if (process.env.REACT_APP_MODE === 'desktop') {
            if (!props.modemStatus.status || props.systemData.serialPortError) 
                return "AGUARDANDO MODEM";
            if (noPower) 
                return "ONLINE - SEM REDE AC";
            return panelStatus || "NÃO INFORMADO";
        }

        switch (guardiaoStatus) {
            case GuardiaoStatusEnum.NAO_INFORMADO:
                return "AGUARDANDO GUARDIÃO";
            case GuardiaoStatusEnum.OFFLINE:
                return "GUARDIÃO LOCAL OFFLINE";
            case GuardiaoStatusEnum.ONLINE_SEM_MODEM:
                return "AGUARDANDO MODEM";
            default:
                return noPower 
                    ? "ONLINE - SEM REDE AC" 
                    : panelStatus || "NÃO INFORMADO";
        }
    };

    const renderNetworkStatus = () => {
        if (process.env.REACT_APP_MODE === 'desktop') {
            return (!props.modemStatus.status || props.systemData.serialPortError) 
                ? "AGUARDANDO MODEM" 
                : !!network.status 
                    ? network.status 
                    : "Não informado";
        }

        // Web mode
        if (!GuardiaoStatusEnum.canShowAmplifiers(guardiaoStatus)) {
            switch (guardiaoStatus) {
                case GuardiaoStatusEnum.NAO_INFORMADO:
                    return "AGUARDANDO GUARDIÃO";
                case GuardiaoStatusEnum.OFFLINE:
                    return "GUARDIÃO LOCAL OFFLINE";
                case GuardiaoStatusEnum.ONLINE_SEM_MODEM:
                    return "AGUARDANDO MODEM";
                default:
                    return "NÃO INFORMADO";
            }
        }

        return !!network.status ? network.status : "Não informado";
    };

    return (
        <>
            <style>{`
                .info-box {
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }
                .info-box:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
                }
                .info-box--clickable {
                    cursor: pointer;
                }
                .info-box--clickable:hover {
                    background: linear-gradient(135deg, rgba(52, 152, 219, 0.08) 0%, rgba(41, 128, 185, 0.08) 100%);
                    border-width: 5px;
                }
                .info-box--clickable:active {
                    transform: translateY(-1px);
                }

                /* Efeitos específicos para cards de evento/alarme */
                .info-card {
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }
                .info-card:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
                }
            `}</style>
            <main class="container info-box-container">

            {!hideAmplifier || syncing ?
                <></>
                :
                <div class="info-box info-box--curved info-box--full" data-status="LIGA" style={{ marginBottom: '1.5rem' }}>
                    <div class="info-box__header">
                        <h4 class="info-box__title my-5">MODEM NÃO ENCONTRADO</h4>
                    </div>
                    <div class="info-box__body my-5">
                        <i className={`df df-xl df-modem-off color-danger`} aria-hidden="true" ></i>
                    </div>
                    <div class="info-box__footer my-5">
                        <span>
                            Não foi possível estabelecer conexão com o modem USB.<br />
                            Verifique o modem e, caso necessário, reinicie o Guardião 2.0.
                        </span>
                    </div>
                </div>

            }


            <div class="info-box info-box--curved info-box--full info-box--serial">
                <div class="info-box__header">
                    <h4 class="info-box__title">Número de Série da Central</h4>
                </div>
                <div class="info-box__body">
                    {
                        props.systemData.name !== undefined ?
                            <>
                                <p class="h1 mb-1 mt-2">
                                    {props.systemData.serialKeys}
                                </p>

                                <p class="h5 mt-0 mb-2">
                                    {props.systemData.name}
                                </p>
                            </>
                            :
                            <span class="h2">{props.systemData.serialKeys}</span>
                    }
                </div>
                <div class="info-box__footer"></div>
            </div>

            <div className={`info-box info-box--curved info-box--row3 ${getClickableClass()}`} onClick={process.env.REACT_APP_MODE === 'desktop' ? navigateToAmplifiers : undefined}>
                <div class="info-box__header">
                    <h4 class="info-box__title">Status da Central</h4>
                </div>
                <div class="info-box__body">
                    {renderStatusIcon()}
                </div>
                <div class="info-box__footer">
                    <span>
                        {process.env.REACT_APP_MODE === 'desktop'
                            ?
                            (!props.modemStatus.status || props.systemData.serialPortError) ? "AGUARDANDO MODEM" : noPower === true ? "ONLINE - SEM REDE AC" : panelStatus !== undefined ? panelStatus : "NÃO INFORMADO"
                            :
                            guardiaoStatus === GuardiaoStatusEnum.NAO_INFORMADO
                                ? "AGUARDANDO GUARDIÃO"
                                : guardiaoStatus === GuardiaoStatusEnum.OFFLINE
                                    ? "GUARDIÃO LOCAL OFFLINE"
                                    : guardiaoStatus === GuardiaoStatusEnum.ONLINE_SEM_MODEM
                                        ? "AGUARDANDO MODEM"
                                        : noPower === true
                                            ? "ONLINE - SEM REDE AC"
                                            : panelStatus !== undefined
                                                ? panelStatus
                                                : "NÃO INFORMADO"
                        }
                    </span>
                </div>
            </div>

            {/* TODO: BLOCO MODELO PARA REFATORAÇÃO => Seguir esse padrão */}
            <div class="info-box info-box--curved info-box--row3">
                <div class="info-box__header">
                    <h4 class="info-box__title">Modo de Operação</h4>
                </div>
                <div class="info-box__body">
                    {process.env.REACT_APP_MODE === 'desktop' && renderDesktopIcon()}
                    {process.env.REACT_APP_MODE === 'web' && renderWebIcon()}
                </div>
                <div class="info-box__footer">
                    {(process.env.REACT_APP_MODE === 'desktop') &&
                        <span>{(!props.modemStatus.status || props.systemData.serialPortError) ? "AGUARDANDO MODEM" : panelMode}</span>
                    }
                    {(process.env.REACT_APP_MODE === 'web') &&
                        <span>
                            {guardiaoStatus === GuardiaoStatusEnum.NAO_INFORMADO
                                ? "AGUARDANDO GUARDIÃO"
                                : guardiaoStatus === GuardiaoStatusEnum.OFFLINE
                                    ? "GUARDIÃO LOCAL OFFLINE"
                                    : guardiaoStatus === GuardiaoStatusEnum.ONLINE_SEM_MODEM
                                        ? "AGUARDANDO MODEM"
                                        : panelMode}
                        </span>
                    }
                </div>
            </div>

            {process.env.REACT_APP_MODE === 'desktop'
                ?
                <div className={`info-box info-box--curved info-box--row3 ${getClickableClass()}`} onClick={process.env.REACT_APP_MODE === 'desktop' ? navigateToAmplifiers : undefined} data-status={!!props.modemStatus.status ? '' : syncing ? 'buscando' : 'LIGA'}>
                    <div class="info-box__header">
                        <h4 class="info-box__title">Modem USB</h4>
                    </div>
                    <div class="info-box__body">
                        <i className={!!props.modemStatus.status ? 'fa fa-usb fa-4x fa-rotate-270 color-success' : syncing ? 'fa fa-usb fa-4x fa-rotate-270 color-info' : 'df df-xl df-modem-off color-danger'} aria-hidden="true" ></i>
                    </div>
                    <div class="info-box__footer">
                        <span style={{ color: props.systemData.serialPortError ? "#FF3B30;" : "inheret" }}>
                            {syncing ? "SINCRONIZANDO" : !props.modemStatus.status
                                ? "NÃO ENCONTRADO"
                                : props.systemData.serialPortError
                                    ? `ERRO CONEXÃO - ${sessionStorage.getItem("serialPortNumber")}`
                                    : `Conectado - ${sessionStorage.getItem("serialPortNumber")}`}
                        </span>
                    </div>
                </div>
                :
                <div class="info-box info-box--curved info-box--row3">
                    <div class="info-box__header">
                        <h4 class="info-box__title">Guardião Desktop</h4>
                    </div>
                    <div class="info-box__body">
                        <i className={
                            guardiaoStatus === GuardiaoStatusEnum.NAO_INFORMADO
                                ? "fa fa-laptop fa-4x color-disabled"
                                : guardiaoStatus === GuardiaoStatusEnum.ONLINE
                                    ? "fa fa-laptop fa-4x color-success"
                                    : guardiaoStatus === GuardiaoStatusEnum.ONLINE_SEM_MODEM
                                        ? "fa fa-laptop fa-4x color-warning"
                                        : "fa fa-laptop fa-4x color-danger"
                        } aria-hidden="true"></i>
                    </div>
                    <div class="info-box__footer">
                        <span>
                            {guardiaoStatus === GuardiaoStatusEnum.NAO_INFORMADO
                                ? "Não informado"
                                : guardiaoStatus === GuardiaoStatusEnum.ONLINE_SEM_MODEM
                                    ? "Online - Sem Modem"
                                    : guardiaoStatus}
                        </span>
                    </div>
                </div>
            }

            <div className={`info-box info-box--curved info-box--row3 ${getClickableClass()}`} onClick={process.env.REACT_APP_MODE === 'desktop' ? navigateToAmplifiers : undefined} data-action="network-health" data-tippy data-tippy-content={
                network.online !== undefined || network.total !== undefined
                    ? `Amplificadores: ${network.online} de ${network.total}`
                    : ""
            }
                title={
                    network.online !== undefined || network.total !== undefined
                        ? `Amplificadores: ${network.online} de ${network.total}`
                        : ""
                }>
                <div class="info-box__header">
                    <h4 class="info-box__title">Rede de Amplificadores</h4>
                </div>
                <div class="info-box__body">
                    {renderNetworkIcon()}
                </div>
                <div class="info-box__footer">
                    <span>{renderNetworkStatus()}</span>
                </div>
            </div>

            <div className={`info-box info-box--curved ${getSecondRowClass()} ${hasNewEvent ? 'info-box--alert' : ''} ${getClickableClass()}`} onClick={process.env.REACT_APP_MODE === 'desktop' ? navigateToEvents : undefined}>
                <div class="info-box__header">
                    <h4 class="info-box__title">Eventos</h4>
                </div>
                <div class="info-box__body">
                    <span class="h1 color-warning">
                        {licenseInfo.isValid
                            ?
                            <>{events.length}</>
                            :
                            <>-</>
                        }
                    </span>
                </div>
                <div class="info-box__footer">
                    <span>Hoje</span>
                </div>
            </div>

            <div className={`info-box info-box--curved ${getSecondRowClass()} ${hasNewAlarm ? 'info-box--alert' : ''} ${getClickableClass()}`} onClick={process.env.REACT_APP_MODE === 'desktop' ? navigateToAlarms : undefined}>
                <div class="info-box__header">
                    <h4 class="info-box__title">Alarmes</h4>
                </div>
                <div class="info-box__body">
                    <span class="h1 color-danger">
                        {licenseInfo.isValid
                            ?
                            <>{alarms.length}</>
                            :
                            <>-</>
                        }
                    </span>
                </div>
                <div class="info-box__footer">
                    <span>Hoje</span>
                </div>
            </div>

            <div className={`info-box info-box--curved ${getSecondRowClass()} ${getClickableClass()}`} onClick={process.env.REACT_APP_MODE === 'desktop' ? openUpdateModal : undefined}>
                <div class="info-box__header">
                    <h4 class="info-box__title">Versão</h4>
                </div>
                <div class="info-box__body">
                    <span class="h1 color-info">
                        {process.env.REACT_APP_BUILD_VERSION}
                    </span>
                </div>
                <div class="info-box__footer">
                    <span>
                        {process.env.REACT_APP_BUILD_TYPE}
                    </span>
                </div>
            </div>

            {process.env.REACT_APP_MODE !== 'web' ?

                <div className={`info-box info-box--curved info-box--row4 ${getClickableClass()}`} onClick={process.env.REACT_APP_MODE === 'desktop' ? navigateToLicenses : undefined} onMouseEnter={licenseWarning}>
                    <div class="info-box__header">
                        <h4 class="info-box__title">Tipo da Licença</h4>
                    </div>
                    <div class="info-box__body">
                        <span className={
                            process.env.REACT_APP_MODE === 'web'
                                ? "h2 color-info text-center"
                                : !licenseInfo.isValid
                                    ? "h2 color-danger text-center"
                                    : licenseInfo.validDays > 30
                                        ? "h2 color-info text-center"
                                        : licenseInfo.validDays > 7 && licenseInfo.validDays <= 30
                                            ? "h2 color-warning text-center"
                                            : "h2 color-danger text-center"
                        }>
                            {
                                process.env.REACT_APP_MODE === 'web'
                                    ? "Web"
                                    : licenseInfo.type === "Inválida"
                                        ? "-"
                                        : licenseInfo.type === "Pro Local"
                                            ? getLicenceDisplayName()
                                            : licenseInfo.type
                            }
                        </span>
                    </div>
                    <div class="info-box__footer">
                        {process.env.REACT_APP_MODE === 'web'
                            ? <span>Ativa</span>
                            : licenseInfo.isValid
                                ? licenseInfo.validDays > 0
                                    ? <span>Ativa</span>
                                    : <span>Expirada</span>
                                : <span>Inválida</span>
                        }
                    </div>
                </div>

                : <></>
            }

            {licenseInfo.validDays > 0
                ?
                <div className={`info-box info-box--curved ${getSecondRowClass()} ${getClickableClass()}`} onClick={process.env.REACT_APP_MODE === 'desktop' ? navigateToLicenses : undefined} data-action="expiration-license">
                    <div class="info-box__header">
                        <h4 class="info-box__title">Expira em</h4>
                    </div>
                    <div class="info-box__body">
                        <span className={licenseInfo.validDays > 30 ? "h2 color-info" : licenseInfo.validDays > 7 && licenseInfo.validDays <= 30 ? "h2 color-warning" : "h2 color-danger"}>
                            {licenseInfo.validDays}
                        </span>
                    </div>
                    <div class="info-box__footer">
                        <span>dias</span>
                    </div>
                </div>
                :
                <div className={`info-box info-box--curved ${getSecondRowClass()}`} data-action="expiration-license">
                    <div class="info-box__header">
                        <h4 class="info-box__title"></h4>
                    </div>
                    <div class="info-box__body">
                        <span className={"h2 color-danger"}>
                            Expirado
                        </span>
                    </div>
                    <div class="info-box__footer">
                        <span></span>
                    </div>
                </div>
            }

        </main>
        </>
    )
}